import React, { FC } from 'react';
import { Tooltip } from '@mui/material';
import { Help } from '@mui/icons-material';

export const SizeTooltip: FC = () => {
  const text = 'It refers to the size in Bytes of the uploaded file (not the edited version). If you want to view the latest version of edited file in the panel, you could download and upload it.';

  return <Tooltip title={text} placement="top">
    <Help />
  </Tooltip>;
};
